var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21V6C6 4.73684 6.73684 4 8 4H16C17.2632 4 18 4.73684 18 6V21C18 21.5439 18.4561 22 19 22C19.5439 22 20 21.5439 20 21V6C20 3.75439 18.2456 2 16 2H8C5.75439 2 4 3.75439 4 6V21C4 21.5439 4.45614 22 5 22C5.54386 22 6 21.5439 6 21ZM19.4912 20.1404L12 15.8421L4.50877 20.1404C4.21053 20.2982 4 20.6316 4 21C4 21.5439 4.45614 22 5 22C5.17544 22 5.35088 21.9474 5.49123 21.8596L12 18.1579L18.5088 21.8596C18.6491 21.9474 18.8246 22 19 22C19.5439 22 20 21.5439 20 21C20 20.6316 19.7895 20.2982 19.4912 20.1404ZM5 6V21L12 17L19 21V6C19 4.31579 17.6842 3 16 3H8C6.31579 3 5 4.31579 5 6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.caeadbb9.svg";
export { ForwardRef as ReactComponent };